import ModalMessages from './ModalMessages';

export default ModalMessages;
